(() => {
  const PRODUCT_ENQUIRY_WEBHOOK = 'https://hooks.zapier.com/hooks/catch/5136622/443bwu3/';

  const newZealandDate = (date) => {
    const parts = new Intl.DateTimeFormat('en-NZ', {
      timeZone: 'Pacific/Auckland',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(date);
    const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
    return `${values.year}-${values.month}-${values.day}`;
  };

  const initialiseCaravanEnquiry = () => {
    const parameters = new URLSearchParams(window.location.search);

    if (parameters.get('intent') !== 'enquiry') return;

    const form = document.querySelector('form.sc-contact-form');
    const message = form?.querySelector('[name="contact[body]"]');

    if (!form || !message) return;

    const formCard = form.closest('.sc-form-card') || form;
    formCard.id = 'caravan-enquiry';
    formCard.style.scrollMarginTop = '24px';
    if (window.location.hash === '#caravan-enquiry') {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => formCard.scrollIntoView({ block: 'start' }));
      });
    }

    const source = parameters.get('source') || '';
    const sourceTitles = {
      '/pages/book-a-viewing': 'Book a Viewing',
      '/pages/caravan-showroom': 'Caravan Showroom',
      '/pages/current-stock': 'Current Caravan Stock'
    };
    const pageTitle = parameters.get('caravan') || sourceTitles[source] || 'Select Caravans website';
    let productUrl = window.location.href;
    if (source) {
      try {
        productUrl = new URL(source, window.location.origin).href;
      } catch (_) {
        productUrl = source;
      }
    }

    form.addEventListener('submit', () => {
      if (form.dataset.shopifyLeadCaptured === 'true') return;
      form.dataset.shopifyLeadCaptured = 'true';

      const now = new Date();
      const payload = new URLSearchParams({
        event_id: `shopify-enquiry-${Date.now()}-${globalThis.crypto?.randomUUID?.() || Math.random().toString(36).slice(2)}`,
        event_time_utc: now.toISOString(),
        event_date_nz: newZealandDate(now),
        form_type: 'caravan_product_enquiry',
        business_line: 'caravans',
        source: 'Shopify Contact Form',
        name: form.querySelector('[name="contact[name]"]')?.value?.trim() || '',
        email: form.querySelector('[name="contact[email]"]')?.value?.trim() || '',
        phone: form.querySelector('[name="contact[phone]"]')?.value?.trim() || '',
        message: message.value?.trim() || '',
        product_title: pageTitle,
        product_url: productUrl,
        campaign: parameters.get('utm_campaign') || 'organic'
      });

      const sent = typeof navigator.sendBeacon === 'function'
        && navigator.sendBeacon(PRODUCT_ENQUIRY_WEBHOOK, payload);
      if (!sent) {
        fetch(PRODUCT_ENQUIRY_WEBHOOK, {
          method: 'POST',
          mode: 'no-cors',
          keepalive: true,
          body: payload
        }).catch(() => {});
      }
    });

    const context = [
      ['Enquiry page', pageTitle],
      ['Model number', parameters.get('model')]
    ].filter(([, value]) => value);

    if (!context.length) return;

    context.forEach(([label, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `contact[${label}]`;
      input.value = value;
      form.appendChild(input);
    });

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseCaravanEnquiry, { once: true });
  } else {
    initialiseCaravanEnquiry();
  }
})();

